


























































































































import Vue from 'vue';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

import ContentItem from '../models/ContentItem';
import DefaultContent from '../data/default_data';
import CpDb from '../data/CpDb';
import { setTimeout } from 'timers';

import WindowsApis from '../api/WindowsApis';

const cpdb = new CpDb();
const win = new WindowsApis();


export default Vue.extend({
  name: 'CopyPaste',
  components: {
    FontAwesomeIcon
  },
  props: {
  },
  data() { 
    return {
      items: new Array<ContentItem>(),
      idbSupported: window.indexedDB !== undefined,
      editedItem: <ContentItem>{},
      mode: "copy",
      showCopiedId: -1,
      showAds: true,
      removeAdsAvailable: false
  }},
  computed: {
    addButtonEnabled(): boolean {
      return this.editedItem.title !== undefined && this.editedItem.title.length > 0
        && this.editedItem.content !== undefined && this.editedItem.content.length > 0;
    },
  },
  methods: {
    copyToClipboard: function(content: string, id: number) {
      let helperInput = document.createElement("textarea");
      helperInput.value = content;
      helperInput.style.position = 'absolute';
      helperInput.style.left = '-1000px';
      document.body.appendChild(helperInput);
      helperInput.select();
      document.execCommand('copy');
      document.body.removeChild(helperInput);
      this.showCopiedId = id;
      let self = this;
      setTimeout(() => self.showCopiedId = -1, 1000);
    },

    async addItem() {
      if (cpdb && this.editedItem.title && this.editedItem.content) {
        await cpdb.addItem(this.editedItem);
        this.editedItem = {} as ContentItem;
        this.items = await cpdb.getAllItems();
      }
    },

    async removeItem(id?: number) {
      if (cpdb && id !== undefined) {
        await cpdb.removeItem(id);
        this.items = await cpdb.getAllItems();
      }
    },

    addItemMode() {
      this.mode = "add";
    },
    copyMode() {
      this.editedItem.title = "";
      this.editedItem.content = "";
      this.mode = "copy";
    },
    deleteMode() {
      this.mode = "delete";
    },

    removeAds() {
      if (win.isWindows) {
        win.purchaseRemoveAds()
          .then(() => this.hideAds())
          .catch(() => console.log('didn\'t buy'));
      }
      else {
      }
    },

    hideAds() {
      localStorage.setItem("showAds", "false");
      this.showAds = false;
    },

    loadAds() {
      let adsbygoogle = window.adsbygoogle || [];
      adsbygoogle.push({});
      adsbygoogle.push({});
    }
  },
  
  async mounted() {
    await cpdb.init(<ContentItem[]>DefaultContent);
    this.items = await cpdb.getAllItems();

    this.showAds = localStorage.getItem("showAds") === null;

    if (this.showAds) {
      if (win.isWindows) {
        this.removeAdsAvailable = true;
        win.isRemoveAdsPurchased()
          .then(() => { this.hideAds() })
          .catch(() => { this.loadAds() });
      }
      else {
        this.loadAds();
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CopyPaste.vue